import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { enrollPasskey, supportsPasskeys } from '@/api/adapter/session';
import { Button } from '@/components/ui/Button';

export default function SignupComplete() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [added, setAdded] = useState(false);
  const [error, setError] = useState('');
  return (
    <div className="onboardingContent">
      <div className="title">
        <h1>Your account is ready</h1>
        <p>
          Your profile has been saved. You are signed in and ready to start.
        </p>
      </div>
      <details className="w-full text-sm text-[--text-dark-secondary]">
        <summary className="cursor-pointer font-medium text-[--state-brand-active] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4">
          Add a passkey (optional)
        </summary>
        <div className="pt-[--spacing-8]">
          {added ? (
            <p role="status">
              Passkey added. You can use it with your username next time.
            </p>
          ) : supportsPasskeys() ? (
            <form
              onSubmit={(event) => {
                event.preventDefault();
                const currentPassword = password;
                setPassword('');
                setBusy(true);
                setError('');
                void enrollPasskey(currentPassword)
                  .then(() => setAdded(true))
                  .catch((reason: unknown) =>
                    setError(
                      reason instanceof Error
                        ? reason.message
                        : 'Could not add a passkey.'
                    )
                  )
                  .finally(() => setBusy(false));
              }}
            >
              <div className="inputGroup">
                <label htmlFor="passkeyPassword">
                  Confirm your password to add a passkey
                </label>
                <input
                  id="passkeyPassword"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  required
                  disabled={busy}
                />
              </div>
              <Button type="submit" disabled={busy}>
                {busy ? 'Adding passkey…' : 'Add passkey'}
              </Button>
            </form>
          ) : (
            <p>
              Passkeys are unavailable in this browser. Your password account is
              ready to use.
            </p>
          )}
          {error && (
            <p role="alert">{error} Your password account remains usable.</p>
          )}
        </div>
      </details>
      <div className="flex w-full justify-end pt-[--spacing-8]">
        <Button
          disabled={busy}
          onClick={() => {
            setPassword('');
            navigate('/dashboard');
          }}
        >
          Continue to dashboard
        </Button>
      </div>
    </div>
  );
}
